import className from './styles.module.css';
import Button from '../../../components/common/Button';
import { useForm } from 'react-hook-form';
import { usePutPasswordResetMutation } from '../../../api/loginApi';
import { useNavigate } from 'react-router';
import {
  changePasswordPolicyMessage,
  matchErrorMessage,
} from '../../../message';
import { useSearchParams } from 'react-router-dom';
import FormBlockItem from '../../../components/common/FormBlockItem';
import LoginLayout from '../../../components/LoginLayout';
import { createPasswordRegisterOptions } from '../../../validators/password';
import { logger } from '../../../services/logger';

const newPasswordRegisterOptions =
  createPasswordRegisterOptions('新しいパスワード');
const newPasswordConfirmationRegisterOptions =
  createPasswordRegisterOptions('新しいパスワード（確認）');

function PasswordReset() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [putPasswordReset] = usePutPasswordResetMutation();

  const form = useForm({ mode: 'onBlur' });

  const { register } = form;

  return (
    <LoginLayout title="パスワード再設定" goBack="login" noGoBackBottomMargin>
      <form
        onSubmit={form.handleSubmit(async (data) => {
          await putPasswordReset({
            newPassword: data.newPassword,
            confirmNewPassword: data.confirmPassword,
            passwordResetToken: searchParams.get('passwordResetToken'),
          })
            .unwrap()
            .then(() => {
              navigate('/login');
            })
            .catch(logger.error);
        })}
      >
        <div className={className.Comment}>
          新しいパスワードを入力してください。
        </div>
        <FormBlockItem
          label="新しいパスワード"
          type="password"
          text={changePasswordPolicyMessage}
          autoComplete="new-password"
          {...register('newPassword', {
            ...newPasswordRegisterOptions,
            deps: ['confirmPassword'],
          })}
          error={
            form.formState.errors.newPassword
              ? String(form.formState.errors.newPassword.message)
              : undefined
          }
        />
        <FormBlockItem
          label="新しいパスワード（確認）"
          type="password"
          autoComplete="new-password"
          {...register('confirmPassword', {
            ...newPasswordConfirmationRegisterOptions,
            validate: (value) => {
              const base =
                newPasswordConfirmationRegisterOptions.validate(value);
              if (base !== true) return base;
              if (value !== form.getValues('newPassword'))
                return matchErrorMessage;
              return true;
            },
          })}
          error={
            form.formState.errors.confirmPassword
              ? String(form.formState.errors.confirmPassword.message)
              : undefined
          }
        />
        <div className={className.ResetButton}>
          <Button
            variants={['fit']}
            type="submit"
            disabled={!form.formState.isValid}
          >
            パスワードを再設定する
          </Button>
        </div>
      </form>
    </LoginLayout>
  );
}

export default PasswordReset;
